import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import {
  collapseClasses,
  ListItemIcon,
  listItemIconClasses,
  ListItemIconProps,
  ListItemText,
  ListItemTextProps,
  MenuItem,
  MenuItemProps,
} from '@mui/material';

export const ChartTooltipInteraction = ({
  primary,
  secondary,
  icon,
  listItemIconProps,
  listItemTextProps,
  ...props
}: Pick<ListItemTextProps, 'primary' | 'secondary'> & {
  icon?: React.ReactNode;
  listItemIconProps?: ListItemIconProps;
  listItemTextProps?: ListItemTextProps;
} & MenuItemProps) => (
  <MenuItem
    {...props}
    sx={{
      [`.${collapseClasses.root}:not(.${collapseClasses.entered}) &`]: {
        [`&:hover`]: { bgcolor: 'initial' },
        color: t => t.palette.colors.neutrals[400],
      },
      [`& .${listItemIconClasses.root}`]: { minWidth: 'auto' },
      minHeight: 'auto',
      ...props.sx,
    }}>
    {icon ? <ListItemIcon {...listItemIconClasses}>{icon}</ListItemIcon> : null}
    <ListItemText
      {...listItemTextProps}
      primaryTypographyProps={{ noWrap: true, ...listItemTextProps?.primaryTypographyProps }}
      primary={<AvTooltip>{primary}</AvTooltip>}
      secondary={secondary}
    />
  </MenuItem>
);
